import { getAssetUrl } from '@/helper/getAssetUrl';

function PostCard(props: {
  name: string;
  imageUrl: string;
  date: string;
  id: number;
}) {
  return (
    <div
      key={props.id}
      className="flex flex-col gap-4 border border-solid border-whiteSubtle w-[325px] p-4 bg-transparent hover:bg-secondary transition-all duration-300 cursor-pointer"
      onClick={() => window.location.assign('/blog/' + props.id)}
    >
      {props.imageUrl != '' && (
        <img
          src={getAssetUrl(props.imageUrl)}
          className="h-1/2"
          alt="post thumbnail"
          loading="lazy"
        />
      )}
      <div className="text-[25px] font-bold text-defaultDark">{props.name}</div>
      <div className="text-subtle font-light">{props.date}</div>
    </div>
  );
}

export default PostCard;
